const prefix = 'movies'

const actionTypes = {
  loaded: `${prefix}/loaded`,
  loading: `${prefix}/loading`,
  loadingFailed: `${prefix}/loadingFailed`
}

export default actionTypes
